import { easeOut } from '../engine/sceneTime';

export const fmtInt = (n) => Math.round(n).toLocaleString('en-GB');

export function fmtBig(n) {
  if (n >= 1e9) return `${(n / 1e9).toFixed(n >= 1e10 ? 0 : 1)}bn`;
  if (n >= 1e6) return `${(n / 1e6).toFixed(n >= 1e7 ? 0 : 1)}m`;
  if (n >= 1e3) return `${(n / 1e3).toFixed(0)}k`;
  return fmtInt(n);
}

// Deterministic count-up driven purely by scene progress (never restarts on re-render).
export function CountUp({ to, progress, format = fmtInt, className = '', style, ease = easeOut }) {
  const value = to * ease(Math.max(0, Math.min(1, progress)));
  return <span className={`pk-count ${className}`} style={style}>{format(value)}</span>;
}
